module.exports = __webpack_public_path__ + "1435d522ca704f31772d78306ff73ec7.pdf";